import { useEffect } from "react"

import { CustomInput, CustomButton, Modal, SelectGamesModal, SelectTrialGamesModal } from "../components"
import { COLORS } from "../constants"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link, useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useQuery } from "../features"
import { useState } from "react"
import SwiperCore, { Navigation, Mousewheel, Autoplay } from 'swiper';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import Speech from 'react-speech';
import Helmet from "react-helmet"
import gameplay_pig from "../assets/images/gameplay_pig.svg"
import Sign from "../assets/images/Sign.svg"
import Loading from "./Loading"
import useSound from "use-sound";
import wrongAnswer from "../assets/audio/wrong.wav"
import reveal from "../assets/audio/reveal.wav"
import correctAnswer from "../assets/audio/correct.wav"
import Logo from "../assets/images/logo.png"
import styled from "styled-components"
import grass from "../assets/images/grass.svg"
import speaker from "../assets/images/speaker.svg"
import axios from "axios";
import { replace } from "../features"

SwiperCore.use([Navigation, Mousewheel, Autoplay]);

const StyledInfo = styled.div`
    position: absolute;
    top: 20px;
    left: 40px;
`;
const StyledGrass = styled.div`
    width: 100%;
    background-image: url(${grass});
    /* padding-top: 50%; */
    height: 120px;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    bottom: 0;

`;
// Progress Bar. Later will be separated to another component.
const CountDownWrapper = styled.div`
    position: absolute;
    bottom: 0;
        left: -70px;
    font-size: 25px;

    //for responsive
    /* top: 20px;
    right: -90px; */

    /* @media screen and (max-width: 575px) {
  
        top: 30px;
        right: -65px;
       

    }
    @media screen and (min-width: 577px) {
  
        bottom: 0;
        left: -70px;
 

} */


`;
const SpeechContainer = styled.div`
    right: -15px;
    top: 115px;

    //for responsive
    /* top: 20px;
    right: -90px; */

    @media screen and (max-width: 575px) {
        right: -10px;
        /* top: 90px; */
         top: 70px;
    }
`;
const StyledProgressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    height: 17px;
    width: 100%;
    background-color: #0C5F7D;
    border-radius: 50px;
   
`;
const StyledProgressCircle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    color: ${props => props.correct ? COLORS.text_dark_green : props.incorrect ? "#731D1D" : "#0B3146"};
    border-radius: 50%;
    margin-top: -10px;
    background-color: ${props => props.correct ? COLORS.green : props.incorrect ? "#E33838" : "#0C5F7D"};
    transform: ${props => props.current ? "scale(1.2)" : "none"};
    transition: all 0.2s;
`;
const StyledSpeakerButton = styled.img`
    position: absolute;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover{
        opacity: 0.5;
    }
`;
const config = {
    angle: 90,
    spread: 360,
    startVelocity: 40,
    elementCount: 70,
    dragFriction: 0.12,
    duration: 3000,
    stagger: 3,
    width: "10px",
    height: "10px",
    perspective: "500px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
};
function Practice(props) {
    const { levelno, gameno } = props.match.params;
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();
    let query = useQuery();
    const ref = query.get('ref')
    const user_role = useSelector(state => state.auth.user.user_role)
    const user = useSelector(state => state.auth.user.user)
    const [gamesModal, setGamesModal] = useState(false);
    const [activeConfetti, setActiveConfetti] = useState(false);
    const [loading, setLoading] = useState(true)
    const [timerPlaying, setTimerPlaying] = useState(false)
    const [questions, setQuestions] = useState([])
    const [totalScore, setTotalScore] = useState(0);
    const [timerKey, setTimerKey] = useState(1)
    const [modalVisible, setModalVisible] = useState(false);
    const [currentQuestionID, setCurrentQuestionID] = useState(0);
    const [playReveal] = useSound(reveal, { interrupt: true, volume: 0.7 });
    const [playCorrect] = useSound(correctAnswer, { interrupt: true, volume: 0.7 });


    const [questionAnswers, setQuestionAnswers] = useState([
        { id: 0, answer: 1, word: '', revealed: 0 },
        { id: 1, answer: 0, word: '', revealed: 0 },
        { id: 2, answer: 0, word: '', revealed: 0 },
        { id: 3, answer: 0, word: '', revealed: 0 },
        { id: 4, answer: 0, word: '', revealed: 0 },
        { id: 5, answer: 0, word: '', revealed: 0 },

    ]);
    useEffect(() => {
        axios.get(`${api}/qt/questions/${levelno}/${gameno}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            setQuestions(result);
            //Update last viewed for both parent teacher, and child pupil
            if (user.email) {
                updateLastViewed(user.email);
            } else if (user.pupil_id) {
                updateLastViewed(user.pupil_id);
            }


            setTimeout(() => {
                setLoading(false);
            }, 1000);

        }).catch(error => {
            setTimeout(() => {
                setLoading(false);
            }, 1000)
            console.log(error);
        });
    }, [])
    const updateLastViewed = async (email_id) => {

        console.log('email_id ' + email_id)
        console.log('level_no ' + levelno)
        console.log('game_no ' + gameno)

        const response = await axios.post(`${api}/pr/update_last_viewed`, { email_id: email_id, level_no: levelno, game_no: gameno })
        console.log(response.data)

    }
    const updateItem = (i, value, word) => {

        const newItems = [...questionAnswers];
        newItems[i].answer = value;
        newItems[i].word = word;

        setQuestionAnswers(newItems);
    }
    const handleNextClick = (event) => {
        event.preventDefault()
        setTimerKey(timerKey + 1)
        setTimerPlaying(true)
        if (currentQuestionID < 5) {
            updateItem(currentQuestionID + 1, 1, "");
            updateItem(currentQuestionID, 2, "");
            setCurrentQuestionID(currentQuestionID + 1)

        } else if (currentQuestionID == 5) {


        }
    }
    // const onInputChange = (event, i) => {
    //     const newItems = [...questionAnswers];
    //     newItems[i].word = event.target.value;

    //     setQuestionAnswers(newItems);
    // }
    const revealAnswer = () => {
        const newItems = [...questionAnswers];
        newItems[currentQuestionID].revealed = 1;
        newItems[currentQuestionID].word = questions[currentQuestionID].word;
        playReveal();
        setQuestionAnswers(newItems);
        setTimerPlaying(false);

    }
    // const checkAnswer = (event) => {
    //     event.preventDefault()
    //     if (questionAnswers[currentQuestionID].word == questions[currentQuestionID].word) {

    //         playCorrect();
    //         updateItem(currentQuestionID, 2, questionAnswers[currentQuestionID].word);

    //     } else {
    //         playWrong();
    //         updateItem(currentQuestionID, 3, questionAnswers[currentQuestionID].word);
    //     }

    // }
    // const countTotalScore = () => {
    //     let count = 0;
    //     questionAnswers.map(item => {
    //         if (item.answer == 2) {
    //             count += 1;
    //         }
    //     })
    //     return count;
    // }
    return (
        <>
            <Modal modalVisible={modalVisible} width="30%">
                <div className="mt-1 text-center color-text-grey">Level {levelno} • Game {gameno}</div>
                <h4 className="color-text-dark-blue text-center mt-2">Game Finished</h4>
                {/* <div className="text-center color-grey">Practice game finished with the score</div>
                <h2 className="text-center mt-2"><span className="color-orange">{countTotalScore()}</span><span className="color-dark-orange">/6</span></h2> */}


                <div className="mt-2">


                    <CustomButton
                        bgColor={COLORS.orange}

                        hover={COLORS.orange_hover}
                        color={COLORS.dark_orange}
                        onClick={() => setGamesModal(true)}
                        style={{ padding: "0 15px", height: 40, fontSize: 17, width: "100%", marginTop: 10 }}
                    >
                        Play Another Game
                    </CustomButton>
                    <CustomButton
                        bgColor={COLORS.green}

                        hover={COLORS.darker_green}
                        color={COLORS.text_dark_green}
                        onClick={() => history.replace('/dashboard')}
                        style={{ padding: "0 15px", height: 40, fontSize: 17, width: "100%", marginTop: 10 }}
                    >
                        Exit
                    </CustomButton>
                </div>


            </Modal>
            <Loading visible={loading} />

            <div className="d-flex justify-content-center flex-column align-items-center">
                <Helmet>
                    <style type="text/css">{`
                    body {
                        background-color: #3290B5;
                    }
                `}</style>
                </Helmet>

                <StyledInfo className="d-none d-md-block">
                    <Link to="/dashboard">
                        <img src={Logo} width={180} height={45} />
                    </Link>
                    <div className="text-white">Level {levelno} • Game {gameno}</div>
                    <div className="text-white">Practice Zone</div>
                </StyledInfo>
                <div className="d-flex justify-content-center flex-column align-items-center text-center gameplay-content">
                    <div className="position-relative">
                        <div className="">
                            <img src={Sign} className="practice-sign" />
                            <h5 className="text-center position-absolute w-100 color-very-dark-blue" style={{ bottom: 7 }}>{questions.length && questions[currentQuestionID].type}</h5>
                            {/* <SpeechContainer className="position-absolute">
                                <div className="position-relative speech" style={{ zIndex: 99, top: 0 }} >
                                    <StyledSpeakerButton src={speaker} />
                                    {questions.length && <Speech text={questions[currentQuestionID].clue} voice="Google UK English Male">aa</Speech>}
                                </div>
                            </SpeechContainer> */}
                        </div>
                    </div>
                    {questions.length &&
                        <Swiper autoHeight={true} allowTouchMove={false} noSwiping={true} slidesPerView={1} className="w-100" navigation={{ nextEl: '.next', prevEl: '.prev' }} onReachEnd={() => setActiveConfetti(true)}>
                            {questions.map((question, i) => {
                                return (
                                    <SwiperSlide key={i} style={{ width: "100%" }}>
                                        <div className="text-white mt-4" style={{ fontSize: 20 }}>{replace(question.clue)}</div>
                                        <div className="color-green mt-3" style={{ fontSize: 19 }}>{question.word.length} letters • first letter is {questions[currentQuestionID].word.charAt(0).toUpperCase()}</div>
                                        <CustomInput name="text" className="w-100 mt-1 color-very-dark-blue" style={{ textAlign: "center", fontSize: 20, height: 60 }} value={questionAnswers[currentQuestionID].word} disabled={true} />
                                    </SwiperSlide>
                                )
                            })}


                        </Swiper>}
                    <div className="d-flex mt-4 justify-content-between w-100">
                        <CustomButton
                            bgColor={COLORS.orange}

                            hover={COLORS.orange_hover}
                            color={COLORS.dark_orange}
                            onClick={() => setTimerPlaying(!timerPlaying)}
                            disabled={questionAnswers[currentQuestionID].revealed == 1}
                            style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                        >
                            {timerPlaying ? "Stop Clock" : "Start Clock"}
                        </CustomButton>
                        <CustomButton
                            bgColor={COLORS.orange}
                            hover={COLORS.orange_hover}
                            color={COLORS.dark_orange}
                            onClick={revealAnswer}
                            disabled={questionAnswers[currentQuestionID].revealed == 1}
                            style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                        >
                            Reveal Answer
                        </CustomButton>
                    </div>
                    <div className="d-flex mt-4 justify-content-between w-100">

                        <div style={{ width: "45%" }} className="d-flex justify-content-center align-items-center">
                            <CountdownCircleTimer
                                key={timerKey}
                                isPlaying={timerPlaying}
                                duration={30}
                                size={70}
                                strokeWidth={8}
                                initialRemainingTime={30}
                                fontSize={40}
                                colors={[
                                    ['#FFFFFF', 0.33],
                                    ['#F7B801', 0.33],
                                    ['#A30000', 0.33],
                                ]}
                            >
                                {/* {({ remainingTime }) => remainingTime} */}
                                {({ remainingTime }) => (
                                    <div style={{ fontSize: 25 }}>
                                        {remainingTime}
                                    </div>
                                )}
                            </CountdownCircleTimer>
                        </div>

                        {currentQuestionID == 5 ?
                            <CustomButton
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                disabled={questionAnswers[5].revealed == 0}
                                className="next"
                                onClick={() => setModalVisible(true)}
                                color={COLORS.text_dark_green}
                                style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                            >
                                Finish
                            </CustomButton>
                            :
                            <CustomButton
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                disabled={questionAnswers[currentQuestionID].revealed == 0}
                                className="next"
                                onClick={(event) => handleNextClick(event)}
                                color={COLORS.text_dark_green}
                                style={{ padding: "0 15px", height: 60, fontSize: 17, width: "45%" }}
                            >
                                Next
                            </CustomButton>

                        }

                    </div>
                    <StyledProgressWrapper className="mt-5">
                        {questionAnswers.map((answer, i) => {
                            return <StyledProgressCircle current={answer.answer == 1} correct={answer.answer == 2} incorrect={answer.answer == 3} key={i}>
                                <h5 className="mb-0">{i + 1}</h5>
                            </StyledProgressCircle>
                        })}


                    </StyledProgressWrapper>
                </div>
                {/* <StyledGrass>
                </StyledGrass> */}
                {/* <img src={grass} className="w-100 position-absolute" style={{ bottom: -120 }} /> */}
            </div>
            {ref == "trial" ? <SelectTrialGamesModal modalVisible={gamesModal} onClose={() => setGamesModal(false)} />
                :
                <SelectGamesModal selectedLevelProps={levelno} inPractice={true} modalVisible={gamesModal} onClose={() => setGamesModal(false)} mode={2} containerheight="72%" isTellFunctionality={false} />
            }

            {/* <SelectGamesModal selectedLevelProps={levelno} inPractice={true} modalVisible={gamesModal} onClose={() => setGamesModal(false)} mode={2} containerheight="72%" isTellFunctionality={false} /> */}

        </>
    );
}

export default Practice;